import React from 'react';
import TabelaClinicas from "../../components/TabelaClinicas";

const Gerente = () => {

   return <div>
      <TabelaClinicas
          colunas={["contribuinte", "nome_comercial", "localidade", "telefone", "email", "accoes"]}
          exportUrl={`${process.env.REACT_APP_API_URL}/clinica/listar?exportar_excel`}
      />
   </div>
};

export default Gerente;

